import { Modal } from 'antd';
import { Notification } from 'services';
import { Button } from 'components/Button';
import UserAvatar from 'components/userAvatar';
import React, { useEffect, useRef, useState } from 'react'


const UserProfilePicChangeModal = React.forwardRef(({ storeImageFile,setImgUrl,imgUrl,setImageFile,handleCancel, onOk, showModal, setProfilePicModal, setShowConfirmModal, setFlag, handleOk, src, setfileInputValue, zIndex = 1050 }, ref) => {


    const [showFileFromLocal, setShowFileFromLocal] = useState(false);
    const valueRef = useRef(null)
    const [saveButtonLoader, setSaveButtonLoader] = useState(false);

    useEffect(() => {
        setShowFileFromLocal(false)
    }, [src]);

    const folderImage = require('../../Assets/userManagementV3/folder 3.png').default
    // "default.png" is the no-photo sentinel elsewhere in this flow
    // (see resolveStaffImageUrl in userEditProfileV3) — treat it the same
    // way here so REMOVE doesn't show up when there's nothing to remove.
    const hasExistingPhoto = Boolean(src && src !== "default.png" && !String(src).includes("default.png"));
    const onCancel = () => {
        setProfilePicModal(false);
        setImgUrl(null);
        handleCancel?.();
    };


    const onChangeFile = (e) => {
        const file = e.target.files[0];

        if (file == undefined) return;

        const isImage = file.type.startsWith("image/");
        if (!isImage) {
            Notification.error("Error", "Only image files are allowed.");
            e.target.value = null;
            return;
        }

        const isLessThan5MB = file.size / 1024 / 1024 < 5;
        if (!isLessThan5MB) {
            Notification.error("Error", "File size exceeds 5MB.");
            e.target.value = null;
            return;
        }

        setfileInputValue(file);
        setImageFile(file)
        setImgUrl(URL.createObjectURL(file));
        setShowFileFromLocal(true)
    };

    return (
        <Modal
            className="modal-round-corner"
            centered
            visible={showModal}
            onOk={handleOk}
            onCancel={onCancel}
            header={null}
            footer={null}
            width={500}
            zIndex={zIndex}
        >
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    marginTop: "25px",
                }}
            >
                <div
                    style={{ fontSize: "24px", fontWeight: 500 }}
                >
                    {imgUrl ? 'Confirm' : 'Change profile photo'}
                </div>

                {!imgUrl
                    ?
                    <div
                        style={{
                            backgroundColor: '#DFDEF5',
                            marginTop: 30,
                            width: 430,
                            height: 155,
                            borderRadius: 12,
                            cursor: 'pointer',
                        }}
                        onClick={() => {
                            if (ref && ref.current) {
                                ref.current.click();
                            } else if (typeof handleOk === 'function') {
                                handleOk();
                            }
                        }}
                    >
                        <div
                            style={{ display: 'flex', justifyContent: 'center', marginTop: 25 }}
                        >
                            <img src={folderImage} alt='folder' />
                            <input
                                type='file'
                                id='file'
                                ref={ref}
                                style={{ display: 'none' }} // Hide the file input
                                accept='.jpg, .png' // Accept only JPG and PNG files
                                onChange={onChangeFile}
                            />
                        </div>
                        <div style={{ fontSize: 16, fontWeight: 500, textAlign: 'center', marginTop: 10 }}>Upload profile photo</div>
                        <div style={{ color: '#636363', textAlign: 'center', marginTop: 10 }}>Supported file format jpg, png</div>

                    </div>
                    :
                    <div style={{marginTop:20}}>
                        <UserAvatar
                            size={50}
                            shape="square"
                            name={''}
                            img={imgUrl}
                            fontWeight={true}
                            userUploadProfile={true}
                        />
                    </div>
                }




            </div>

            {
                !imgUrl ?
                    (hasExistingPhoto && (
                        <div style={{ marginLeft: 10, marginTop: 20 }}>
                            <Button
                                type='primary'
                                onClick={() => { setShowConfirmModal(true); setProfilePicModal(false), setFlag(true) }}
                                style={{ marginRight: 20, backgroundColor: "#FFFFFF", color: "#FF414D", border: '2px solid #FF414D', width: 430 }}
                            >
                                <div>
                                    REMOVE PROFILE PHOTO
                                </div>
                            </Button>
                        </div>
                    ))
                    :
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-evenly",
                            marginTop: "30px",
                        }}
                    >
                        <div>
                            <Button
                                type='primary'
                                onClick={onCancel}
                                style={{ marginRight: 20, backgroundColor: "#FFFFFF", color: "#AEAEAE" }}
                            >
                                <div
                                >
                                    NO
                                </div>
                            </Button>
                        </div>
                        <div>
                            <Button
                                type="primary"
                                loading={saveButtonLoader}
                                onClick={() => {
                                    setSaveButtonLoader(true);
                                    onOk(handleCancel, () => setSaveButtonLoader(false));
                                }}
                            >
                                YES
                            </Button>
                        </div>
                    </div>

            }



        </Modal>
    )
})


export default UserProfilePicChangeModal